import {
    Component,
    OnInit,
    Input,
    HostBinding,
    ViewChild,
    EventEmitter,
    Output,
    ContentChild,
    ElementRef,
    AfterViewInit,
} from "@angular/core";
import {
    FFileSelectDirective,
    FFileDropDirective,
    FFileUploadDirective,
} from "../../directive/index";
import {
    UploadOutput,
    UploadInput,
    UploadFile,
    UploaderOptions,
    FUploadFileExtend,
    DocMetaProperty,
} from "../../model/index";
import { FFileUtils } from "../../utils/index";
import {
    FFileUploadAPIService,
    FFileUploaderService,
} from "../../service/index";
import { NotifyService, NotifyOptions } from "@farris/ui-notify";
import { Observable, Subject } from "rxjs";

import { trigger,style,state,animate,transition } from "@angular/animations";
import { NgZone } from "@angular/core";
import { LocaleService } from "@farris/ui-locale";

@Component({
    selector: "f-file-upload",
    templateUrl: "./f-file-upload.component.html",
    styleUrls: ["./f-file-upload.component.css"],
    providers: [FFileUploaderService],
    animations: [
        trigger("hideUploaded", [
            state("show", style({ opacity: 1, height: "*" })),
            state("hide", style({ opacity: 0, height: 0 })),
            // transition('* => void', [
            //   style({ opacity: 1}),
            //   animate(200, style({ opacity: 0}))
            // ])
            transition("* => hide", animate("0.5s")),
        ]),
    ],
})
export class FFileUploadComponent implements OnInit, AfterViewInit {
    @HostBinding("class.ffileupload") cls = true;
    // 不可见
    @HostBinding("class.ffileupload-unvisible") get visibleState() {
        return !this.visible;
    }
    // 自定义样式
    @HostBinding("class.ffileupload-selfdefine") get selfDirectiveDefine() {
        if (this.fFileUploadDir) {
            return true;
        }
        return false;
    }
    @HostBinding("class.ffileupload-uploading") get uploading() {
        return this.files.length > 0;
    }

    // 不能在Construct里追加el
    @ViewChild("uploadAssist") fFileUploadAssist: ElementRef;
    // 自定义指令
    @ContentChild(FFileUploadDirective) fFileUploadDir: any;
    //
    @ViewChild(FFileSelectDirective) fileUpload: FFileSelectDirective;
    @ViewChild(FFileDropDirective) fileDropUpload: FFileDropDirective;
    // 启用图片预览
    @Input() enableImagePreview = true;
    // 启用立即上传
    @Input() uploadImmediately = false;
    // 上传完成后隐藏
    @Input() uploadedThenHide = true;
    // 禁用状态
    @Input() disabled = false;
    /** 启用分块上传 */
    @Input() enableSliceUpload = true;
    /** 分块上传每片大小，单位：M, 默认 1M/块 */
    @Input() chunkSize = 1;

    private tVisible = true;
    // 是否可见
    @Input()
    set visible(value) {
        this.tVisible = value;
        if (!value) {
            this.reset();
        }
    }
    get visible() {
        return this.tVisible;
    }
    // 需要重置,通过不断的赋值来改变
    @Input() needReset: Observable<any> = new Subject();
    // 启用拖拽
    @Input() enableDrop = false;
    @Input() dropText = "可将文件拖拽此处";
    // 启用选择文件按钮
    @Input() enableSelect = true;
    @Input() selectText = "点击上传";
    // 启用多选
    @Input() multiple = true;
    // 已经上传文件
    @Input() uploadedCount = 0;
    // 公共的扩展数据
    @Input() extendDatas: {
        [key: string]: any;
        extProperty?: DocMetaProperty | null; //
    };
    // 宽度阈值，当宽度超过760时候，没有附件上传时，宽度是固定值，有附件上传时，有最大宽度值
    @Input() widthThreshold = 760;
    // 上传和删除对外抛出的事件
    @Output() fUploadDoneEvent = new EventEmitter<FUploadFileExtend[]>();
    @Output() fUploadRemovedEvent = new EventEmitter<FUploadFileExtend[]>();

    // 允许上传的文件类型
    allowedContentTypes = "*";
    // 默认不限制附件上传个数
    maxUploads = 0;
    // 单位KB，默认是12M
    maxFileSize = "12MB";

    private selfUploadOpts: UploaderOptions = {};
    // 上传配置项
    @Input()
    set options(uploadOpts: UploaderOptions) {
        if (uploadOpts) {
            if (uploadOpts.hasOwnProperty("allowedContentTypes")) {
                this.allowedContentTypes = uploadOpts.allowedContentTypes.join(",");
                this.allowedContentTypes =
                    this.allowedContentTypes == "" ? "*" : this.allowedContentTypes;
            }
            if (uploadOpts.hasOwnProperty("maxUploads")) {
                this.maxUploads = uploadOpts.maxUploads;
            }
            if (uploadOpts.hasOwnProperty("maxFileSize")) {
                this.maxFileSize = FFileUtils.humanizeBytes(
                    1024 * 1024 * uploadOpts.maxFileSize
                );
            }
            this.selfUploadOpts = Object.assign(this.selfUploadOpts, uploadOpts);
        }
    }
    get options() {
        return this.selfUploadOpts;
    }
    /**
     * 每个组可以设置特殊服务参数，来覆盖默认的统一模块级配置
     */
    @Input()
    set extendServerConfig(config: any) {
        if (config) {
            this.fileUploaderSer.setExtendServerConfig(config);
        }
    }
    // 记录文件个数
    files: UploadOutput[];
    // 标记通过选择按钮处理的事件
    uploadSelectInput: EventEmitter<UploadInput>;
    // 标记通过拖拽处理的事件
    uploadDragInput: EventEmitter<UploadInput>;
    // 控制是否显示追加附件的面板
    showAppendPanel = false;
    // 显示loading
    showLoading = false;

    settings = {
        disabled: this.disabled,
        visible: this.visible,
    };
    // 多语言信息
    localInfo
    constructor(
        private uploadAPISer: FFileUploadAPIService,
        private fileUploaderSer: FFileUploaderService,
        private notifyService: NotifyService,
        private ngZone: NgZone
    ) {
        this.files = [];
        this.uploadSelectInput = new EventEmitter<UploadInput>();
        this.uploadDragInput = new EventEmitter<UploadInput>();
        // 重置
        this.needReset.subscribe((data) => {
            this.reset();
        });
        FFileUtils.getLocalState(this.notifyService.localeService);        
    }

    ngOnInit() {
        // 模板的情况下只能是立即上传
        if (this.fFileUploadDir) {
            this.uploadImmediately = true;
        }
        this.computeWidthThreshold();
    }
    /**
     * 视图初始化后
     */
    ngAfterViewInit() { }
    /**
     * 触发绑定
     */
    triggerFileSelect(ev) {
        ev && ev.stopPropagation();
        // 禁用时
        if (this.disabled) {
            return false;
        }
        this.fileUpload.elementRef.nativeElement.click();
    }
    /**
     * 选择附件按钮，处理抛出事件
     * @param output
     */
    selectUploadOutput(output: UploadOutput): void {
        this.uploadOutputHandler(output);
    }
    /**
     * 拖拽区域处理抛出事件
     * @param output
     */
    dropUploadOutput(output: UploadOutput): void {
        if (this.enableSelect) {
            return;
        }
        // 暂不处理拖拽的事件
        if (
            output.type !== "dragOver" &&
            output.type !== "dragOut" &&
            output.type !== "drop"
        ) {
            this.uploadOutputHandler(output);
        }
    }
    /**
     * allAddedToQueue 选中文件追加到队列
     * @param output
     */
    private uploadOutputHandler(output: UploadOutput): void {
        // 显示追加面板
        if (this.showAppendPanel) {
            this.showAppendPanel = false;
        }

        if (output.type === "addedToQueue" && typeof output.file !== "undefined") {
            this.files.push({ type: output.type, file: output.file });
            // 如果启用立即上传
            if (this.uploadImmediately) {
                this.showLoading = true;
                this.startUpload(output.file);
            }
        } else if (output.type === "start") {
            // 开始上传
            this.updateFilesState(output, "");
        } else if (output.type == "done") {
            // 上传完成
            this.updateFilesState(output, "done");
            this.fUploadDoneEvent.emit(
                FFileUtils.changeUploadFileToFileExtend(output.files)
            );
            this.hideAfterLoaded(output);
            // 隐藏正在加载
            if (
                this.uploadImmediately &&
                this.showLoading &&
                this.allFileUploaded()
            ) {
                this.showLoading = false;
            }
        } else if (
            output.type === "cancelled" ||
            output.type === "removed" ||
            output.type == "error"
        ) {
            // 删除或者移除文件
            this.files = this.files.filter((fileOutput: UploadOutput) => {
                return (
                    output.files.findIndex((item) => fileOutput.file.id == item.id) < 0
                );
            });
            // 隐藏正在加载
            if (
                this.uploadImmediately &&
                this.showLoading &&
                this.allFileUploaded()
            ) {
                this.showLoading = false;
            }
            this.showNotify(output);
        } else if (
            output.type === "rejected" &&
            typeof output.file !== "undefined"
        ) {
            // 上传被拒绝
            this.showNotify(output);
            // 隐藏正在加载
            if (
                this.uploadImmediately &&
                this.showLoading &&
                this.allFileUploaded()
            ) {
                this.showLoading = false;
            }
        }
    }

    private showNotify(output) {
        let notifyType = "warning";
        if (output.type == "cancelled" || output.type == "removed") {
            notifyType = "success";
        }
        let message = output.hasOwnProperty("message") ? output["message"] : "";
        this.notifyService[notifyType](<NotifyOptions>{
            msg: message,
            timeout: 3000,
        });
    }
    // 判断是否所有文件都已上传
    private allFileUploaded() {
        let findNotDoneIndex = this.files.findIndex((item) => {
            let doneTypes = ["done", "cancelled", "removed"];
            let findTypeIndex = doneTypes.findIndex((type) => {
                return type == item.type;
            });
            return findTypeIndex == -1;
        });
        return findNotDoneIndex == -1 ? true : false;
    }
    /**
     * 更新附件的状态
     * @param output
     * @param eventType
     */
    private updateFilesState(output: UploadOutput, eventType) {
        let startFiles = [];
        if (output.hasOwnProperty("files") && output.files.length > 0) {
            // 此处更新界面可能有性能问题
            startFiles = output.files;
        } else if (typeof output.file !== "undefined") {
            startFiles = [output.file];
        }
        eventType = eventType ? eventType : output.type;
        startFiles.map((item) => {
            const index = this.files.findIndex(
                (fileOutput) =>
                    typeof item !== "undefined" && fileOutput.file.id === item.id
            );
            // 变更状态
            if (index > -1) {
                this.files[index] = { type: eventType, file: item };
            }
        });
    }

    /**单个文件上传 */
    startUpload(file: UploadFile): void {
        /**
         * Todo:后续可以从上传区块上取内容进行扩展
         */
        const event: UploadInput = this.uploadAPISer.getAssignAPI("upload", {
            file: file,
            type: this.enableSliceUpload ? 'sliceUpload': 'upload',
            data: this.extendDatas,
            chunkSize: this.chunkSize
        });
        this.inputUploadEventEmit(event);
    }
    /**
     * 上传所有
     */
    startUploadAll(): void {
        /**
         *  Todo：后续，如果每个数据不一样，此处的数据得重新归集
         */
        const event: UploadInput = this.uploadAPISer.getAssignAPI("uploadAll", {
            type: this.enableSliceUpload ? 'sliceUpload': "uploadAll",
            files: [],
            data: this.extendDatas,
            chunkSize: this.chunkSize
        });
        this.inputUploadEventEmit(event);
    }
    /**
     * 已上传隐藏属性
     */
    hideAfterLoaded(output: UploadOutput): void {
        //上传完成后删除
        if (this.uploadedThenHide) {
            // this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                // 删除或者移除文件
                let ids = output.files.map((fileItem) => fileItem.id);
                this.files = this.files.filter((fileOutput: UploadOutput) => {
                    let tIndex = ids.findIndex((tId) => tId == fileOutput.file.id);
                    return tIndex > -1 ? false : true;
                });

                const event: UploadInput = this.uploadAPISer.getAssignAPI("hide", {
                    type: "hide",
                    id: ids.join(","),
                });
                this.inputUploadEventEmit(event);
            }, 1000);
            // });
        }
    }
    /**
     * 取消上传
     */
    cancelUpload(id: string): void {
        const event: UploadInput = this.uploadAPISer.getAssignAPI("cancel", {
            id: id,
            type: "cancel",
        });
        this.inputUploadEventEmit(event);
    }
    /**
     * 删除已上传文件
     */
    removelAllUpload(): void {
        const event: UploadInput = this.uploadAPISer.getAssignAPI("removeAll", {
            type: "removeAll",
            files: [],
        });
        this.inputUploadEventEmit(event);
    }
    /**
     * 删除已上传文件
     */
    removeFile(id: string): void {
        const event: UploadInput = this.uploadAPISer.getAssignAPI("remove", {
            id: id,
            type: "remove",
        });
        this.inputUploadEventEmit(event);
    }
    /** */
    /**
     *
     * @param bytes
     */
    formateBytes(bytes) {
        return FFileUtils.humanizeBytes(bytes);
    }
    /**
     * 判断是图片
     * @param type
     */
    isImage(type) {
        return type.indexOf("image") > -1;
    }
    // inProgress(progress) {
    //   console.log('进入inProgress');
    //   if (progress.data.percentage == 100) {
    //     return 'done'
    //   }
    //   if (progress.data.percentage == 0) {
    //     return 'uploadi';
    //   }
    //   return 'progress';
    // }

    /**
     * 是否判断有类型限制
     */
    judgeContentTypeLimit() {
        let tTypes = this.allowedContentTypes.split(",");
        let hasAllIndex = tTypes.findIndex((item) => {
            return item == "*";
        });
        return hasAllIndex == -1;
    }
    /**
     * 判断是否有文件大小的限制
     */
    judegeFileSizeLimit() {
        return this.maxFileSize != "0 Byte";
    }
    /**
     * 追加
     */
    appendNewFiles(ev) {
        //启用拖拽
        if (this.enableDrop) {
            this.showAppendPanel = true;
        } else {
            ev && ev.stopPropagation();
            this.triggerFileSelect(ev);
        }
    }
    /**
     * 关闭追加面板
     */
    closeAppendPanel() {
        this.showAppendPanel = false;
    }
    /**
     * 统一触发 附件选择和拖拽附件的事件
     * @param ev
     */
    private inputUploadEventEmit(ev: UploadInput) {
        // 如果文件上传启用
        if (this.enableSelect) {
            this.uploadSelectInput.emit(ev);
        } else {
            this.uploadDragInput.emit(ev);
        }
    }
    // 重置方法
    reset() {
        this.files = [];
        // 如果文件上传启用
        if (this.enableSelect) {
            this.fileUpload && this.fileUpload.reset();
        } else {
            this.fileDropUpload && this.fileDropUpload.reset();
        }
        this.computeWidthThreshold();
    }
    /**
     * 计算阈值
     */
    private computeWidthThreshold() {
        //
        this.ngZone.runOutsideAngular(() => {
            let self = this;
            setTimeout(() => {
                let tNeedComputedCls = false;
                if (self.fFileUploadDir || !self.visible) {
                    tNeedComputedCls = false;
                }
                // 计算元素
                let assistEl = self.fFileUploadAssist
                    ? self.fFileUploadAssist.nativeElement
                    : null;

                if (assistEl) {
                    assistEl.parentElement.classList["add"]("ffileupload-default");
                }

                return;

                // // 超过阈值
                // if (assistEl && assistEl.getBoundingClientRect().width > self.widthThreshold) {
                //   tNeedComputedCls = true;
                // } else {
                //   tNeedComputedCls = false;
                // }
                // if (assistEl) {
                //   let actionFun = tNeedComputedCls ? 'add' : 'remove';
                //   assistEl.parentElement.classList[actionFun]('ffileupload-default');
                // }
            }, 0);
        });
    }
}
